function PriceSeperator(){
    return function (input) {
        return new Intl.NumberFormat("fa-IR").format(input);
    };
}

module.exports = ngModule => {
    ngModule.filter('PriceSeperator', PriceSeperator);
};